export default {
  interactiveImage: {
    dskHotspotId: '{E8CD1447-F3EC-4882-967C-CA8A8ED6806A}',
    mblHotspotId: '{5E68888F-5653-4392-940E-D0B4A5211823}',
  },
  homeTemplateId: 'cac1b333-dec6-48cc-bdbc-169d4dda9da0',
  lineListingPageTemplateId: '67841ff0-9988-4b2c-bd0f-3558abc0056b',
  lineDetailPageTemplateId: '42bbf80e-7035-42ea-a7b7-f6dbb36f8808',
  seriesDetailPageTemplateId: '4f7e9371-7fde-4919-9cb9-aea9f507859b',
  modelDetailPageTemplateId: '4e2cc79c-91d0-46f1-a7de-c134d698031d',
};
